import { useInfiniteQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getFollowing = async (
  id: string,
  limit?: number,
  search?: string,
  pageParam?: number | undefined,
) => {
  const from = pageParam || 0
  const to = from + (limit || 10) - 1
  let req = supabase
    .from('following_users')
    .select(`
      *,
      profile:user_profiles!follow_user_id!inner (*)
    `, { count: 'exact' })
    .eq('user_id', id)
    .order('created_at', { ascending: false })
  if (search) {
    req = req.or(
      `username.ilike.%${search}%,first_name.ilike.%${search}%,last_name.ilike.%${search}%`,
      { foreignTable: 'profile' },
    )
  }
  const { data, error } = await req.range(from, to);

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useUserFollowingList(id: string, limit?: number, search?: string) {
  return useInfiniteQuery({
    queryKey: ['useUserFollowingList', id],
    queryFn: ({ pageParam }) => getFollowing(id, limit, search, pageParam),
    enabled: Boolean(id),
    staleTime: 60000,
    getPreviousPageParam: () => undefined,
    getNextPageParam: (lastPage: any, pages?: any[]) => (
      lastPage.length
        ? (pages || []).reduce((acc, v) => (acc + (v?.length || 0)), 0)
        : undefined
    ),
  })
}
